module.exports = __webpack_public_path__ + "static/sport/game-4.86785f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/game-4.png
// module id = M9pG
// module chunks = 0